module.exports = __webpack_public_path__ + "img/CCSD.e5eac54.jpg";